import {DesignationsList} from "./DesignationsList";
import {DesignationsEdit} from "./DesignationsEdit";
import {DesignationsCreate} from "./DesignationsCreate";

export default {
    list: DesignationsList,
    create: DesignationsCreate,
    edit: DesignationsEdit
};
